import { Can } from '@/components/can/Can';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/faq/review-ratings')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Can rule={{ allOf: [PERMS.reviewRatings.list] }}>
      <Outlet />
    </Can>
  );
}
